import React, { Component } from "react";
import { Card, CardBody, CardGroup } from "reactstrap";
import AuthService from "../../../components/AuthService";
import { List } from "react-content-loader";

class DashboardBuild extends Component {
  constructor(props) {
    super(props);
    this.Auth = new AuthService();
    this.fetchNumberOfUsers = this.fetchNumberOfUsers.bind(this);
    this.state = {};
  }

  fetchAllData() {
    this.fetchNumberOfUsers(this);
    this.fetchnumberOfRegisteredUsersLast30days(this);
    this.fetchAverageLevel(this);
    this.fetchAverageScore(this);
    this.fetchCountStats(this, "smiles");
    this.fetchCountStats(this, "challenges");
    this.fetchCountStats(this, "succeedQuizz");
    this.fetchCountStats(this, "answers");
    this.fetchCountStats(this, "share");
    this.fetchCountStats(this, "inactive");
    this.fetchCountStats(this, "superSmiles");
  }

  componentDidUpdate(prevProps) {
    if (prevProps.newFetch !== this.props.newFetch) {
      this.fetchAllData();
    }
  }

  componentDidMount() {
    this.fetchAllData();
  }

  fetchCountStats(thus, type) {
    let url = "";
    switch (type) {
      case "smiles":
        url = "selectSmilesCount";
        break;
      case "superSmiles":
        url = "selectSuperSmilesCount";
        break;
      case "challenges":
        url = "selectChallengeSucceedCount";
        break;
      case "succeedQuizz":
        url = "selectQuizzSucceedCount";
        break;
      case "answers":
        url = "resultsByQuestions";
        break;
      case "share":
        url = "selectShareCount";
        break;
      case "inactive":
        url = "selectInactives";
        break;
    }
    if (url.length) {
        this.Auth.httpRequest(
            "GET",
            "api/dashboard/count/" + url + this.props.request
        ).then(function(datas) {
            switch (type) {
              case "smiles":
                thus.setState(previousState => ({
                  numberOfSmilesCollected: datas.data[0].count
                }));
                break;
              case "superSmiles":
                thus.setState(previousState => ({
                  numberOfSuperSmilesSent: datas.data[0].count
                }));
                break;
              case "challenges":
                thus.setState(previousState => ({
                  numberOfChallenges: datas.data[0].count
                }));
                break;
              case "succeedQuizz":
                thus.setState(previousState => ({
                  numberOfQuizzSucceeded: datas.data[0].count
                }));
                break;
              case "answers":
                thus.setState(previousState => ({
                  numberOfQuestionsAnswered: datas.data[0].count
                }));
                break;
              case "share":
                thus.setState(previousState => ({
                  numberOfShare: datas.data[0].count
                }));
                break;
              case "inactive":
                thus.setState(previousState => ({
                  numberOfInactiveUsers: datas.data[0].count
                }));
                break;
            }
        }).catch(error => {
            if (!thus.props.isAdmin && !thus.props.error) {
                thus.props.notifyError();
            }
        });
    }
  }

  fetchNumberOfUsers(thus) {
    this.Auth.httpRequest(
      "GET",
      "api/dashboard/numberOfUsers" + this.props.request
    ).then(function(datas) {
      thus.setState(previousState => ({
        numberOfUsers: datas.data[0].numberOfUsers
      }));
    }).catch(error => {
        if (!thus.props.isAdmin && !thus.props.error) {
            thus.props.notifyError();
        }
    });
  }

  fetchnumberOfRegisteredUsersLast30days(thus) {
    this.Auth.httpRequest(
      "GET",
      "api/dashboard/numberOfRegisteredUsersLast30days" + this.props.request
    ).then(function(datas) {
      thus.setState(previousState => ({
        numberOfRegisteredUsersLast30days: datas.data[0].numberOfUsers
      }));
    }).catch(error => {
        if (!thus.props.isAdmin && !thus.props.error) {
            thus.props.notifyError();
        }
    });
  }

  fetchAverageLevel(thus) {
    this.Auth.httpRequest(
      "GET",
      "api/dashboard/averageLevel" + this.props.request
    ).then(function(datas) {
      thus.setState(previousState => ({
        averageLevel: datas.data[0].averageLevel
      }));
    }).catch(error => {
        if (!thus.props.isAdmin && !thus.props.error) {
            thus.props.notifyError();
        }
    });
  }

  fetchAverageScore(thus) {
    this.Auth.httpRequest(
      "GET",
      "api/dashboard/averageScore" + this.props.request
    ).then(function(datas) {
      thus.setState(previousState => ({
        averageQuestion: datas.data[0].count
      }));
    }).catch(error => {
        if (!thus.props.isAdmin && !thus.props.error) {
            thus.props.notifyError();
        }
    });
  }

  render() {
    let numberOfUsers,
      numberOfRegisteredUsersLast30days,
      averageLevel,
      averageQuestion,
      numberOfSmilesCollected,
      numberOfChallenges,
      numberOfSuperSmilesSent,
      numberOfQuizzSucceeded,
      numberOfShare;

    if (this.state.numberOfShare !== undefined) {
      numberOfShare = (
        <Card className="text-white bg-primary">
          <CardBody className="pb-0">
            <h2 className="mb-0">{this.state.numberOfShare}</h2>
            <h5>partages</h5>
          </CardBody>
        </Card>
      );
    } else {
      numberOfShare = (
        <Card>
          <List />
        </Card>
      );
    }

    if (this.state.numberOfSmilesCollected !== undefined) {
      numberOfSmilesCollected = (
        <Card className="text-white bg-primary">
          <CardBody className="pb-0">
            <h2 className="mb-0">{this.state.numberOfSmilesCollected}</h2>
            <h5>sourires collectés</h5>
          </CardBody>
        </Card>
      );
    } else {
      numberOfSmilesCollected = (
        <Card>
          <List />
        </Card>
      );
    }

    if (this.state.numberOfSuperSmilesSent !== undefined) {
      numberOfSuperSmilesSent = (
        <Card className="text-white bg-primary">
          <CardBody className="pb-0">
            <h2 className="mb-0">{this.state.numberOfSuperSmilesSent}</h2>
            <h5>Mercis envoyés</h5>
          </CardBody>
        </Card>
      );
    } else {
      numberOfSuperSmilesSent = (
        <Card>
          <List />
        </Card>
      );
    }

    if (this.state.numberOfQuizzSucceeded !== undefined) {
      numberOfQuizzSucceeded = (
        <Card className="text-white bg-primary">
          <CardBody className="pb-0">
            <h2 className="mb-0">{this.state.numberOfQuizzSucceeded}</h2>
            <h5>quiz réussis</h5>
          </CardBody>
        </Card>
      );
    } else {
      numberOfQuizzSucceeded = (
        <Card>
          <List />
        </Card>
      );
    }

    if (this.state.numberOfChallenges !== undefined) {
      numberOfChallenges = (
        <Card className="text-white bg-primary">
          <CardBody className="pb-0">
            <h2 className="mb-0">{this.state.numberOfChallenges}</h2>
            <h5>challenges réussis</h5>
          </CardBody>
        </Card>
      );
    } else {
      numberOfChallenges = (
        <Card>
          <List />
        </Card>
      );
    }

    if (this.state.numberOfUsers !== undefined) {
      numberOfUsers = (
        <Card className="text-white bg-primary">
          <CardBody className="pb-0">
            <h2 className="mb-0">{this.state.numberOfUsers}</h2>
            <h5>collaborateurs</h5>
            {this.state.numberOfInactiveUsers} inactifs
          </CardBody>
        </Card>
      );
    } else {
      numberOfUsers = (
        <Card>
          <List />
        </Card>
      );
    }

    if (this.state.averageLevel !== undefined) {
      averageLevel = (
        <Card className="text-white bg-primary">
          <CardBody className="pb-0">
            <h2 className="mb-0">{this.state.averageLevel}</h2>
            <h5>Niveau moyen</h5>
          </CardBody>
        </Card>
      );
    } else {
      averageLevel = (
        <Card>
          <List />
        </Card>
      );
    }

    if (this.state.numberOfRegisteredUsersLast30days !== undefined) {
      numberOfRegisteredUsersLast30days = (
        <Card className="text-white bg-primary">
          <CardBody className="pb-0">
            <h2 className="mb-0">{this.state.numberOfRegisteredUsersLast30days}</h2>
            <h5>Nouveaux utilisateurs</h5>
            Au cours des 30 derniers jours
          </CardBody>
        </Card>
      );
    } else {
      numberOfRegisteredUsersLast30days = (
        <Card>
          <List />
        </Card>
      );
    }

    return (
      <React.Fragment>
        <CardGroup className="mb-4">
          {numberOfUsers}
          {numberOfRegisteredUsersLast30days}
          {averageLevel}
          {numberOfSmilesCollected}
        </CardGroup>
        <CardGroup className="mb-4">
          {numberOfChallenges}
          {numberOfQuizzSucceeded}
          {numberOfShare}
          {numberOfSuperSmilesSent}
        </CardGroup>
      </React.Fragment>
    );
  }
}

export default DashboardBuild;



// WEBPACK FOOTER //
// ./src/views/Base/ChiffresClesStatistiquesUsage/ChiffresClesStatistiquesUsage.js